import { api } from "../component/constent";

// ======================================================
// GET LIST
// ======================================================
export const getAllocations = async () => {
  const response = await api.get("/entry/allocation");
  return response.data;
};


// ======================================================
// GET SINGLE
// ======================================================
export const getAllocation = async (AllocationHeadCode) => {
  const response = await api.get( 
    `/entry/allocation/${encodeURIComponent(AllocationHeadCode)}`);
  return response.data;
};


// ======================================================
// INSERT
// ======================================================
export const insertAllocation = async (data) => {
  const response = await api.post( "/entry/allocation", data );
  return response.data;
};


// ======================================================
// UPDATE
// ======================================================
export const updateAllocation = async (
  OldAllocation,
  data
) => {
  const response = await api.put(
    `/entry/allocation/${encodeURIComponent(OldAllocation)}`,
    data
  );

  return response.data;
};


// ======================================================
// DELETE
// ======================================================
export const deleteAllocation = async ( Allocation) => {
  const response = await api.delete(
    `/entry/allocation/${encodeURIComponent(Allocation)}`
  );

  return response.data;
};